import { render } from "./ByValueRoadmap.vue?vue&type=template&id=023da1b1"
import script from "./ByValueRoadmap.vue?vue&type=script&lang=js"
export * from "./ByValueRoadmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__